const wordList5 = [
  { pl: 'torba', de: 'die Tasche' },
  { pl: 'klej', de: 'der Klebstoff' },
  { pl: 'tablet', de: 'das Tablet' },
  { pl: 'temperówka', de: 'der Anspitzer' },
  { pl: 'zeszyt', de: 'das Heft' },
  { pl: 'długopis', de: 'der Kugelschreiber' },
  { pl: 'linijka', de: 'das Lineal' },
  { pl: 'gumka', de: 'der Radiergummi' }
];

export default wordList5;